export default __webpack_public_path__ + "static/media/photo--lg--102.c28be89d.jpg";